import { Empty, Spin, Tag } from "antd";

const STATUS_COLORS = {
  positive: "green",
  info: "blue",
  warning: "gold",
  danger: "red",
  neutral: "default"
};

export function StatusTag({ tone = "neutral", children, className = "" }) {
  const normalizedTone = STATUS_COLORS[tone] ? tone : "neutral";

  return (
    <Tag
      color={STATUS_COLORS[normalizedTone]}
      className={`app-status-tag is-${normalizedTone}${className ? ` ${className}` : ""}`}
    >
      {children}
    </Tag>
  );
}

export function AppEmpty({ description = "표시할 내용이 없습니다.", action = null, compact = false }) {
  return (
    <Empty
      className={`app-empty-state${compact ? " is-compact" : ""}`}
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={description}
    >
      {action}
    </Empty>
  );
}

export function ContentLoading({ label = "불러오는 중입니다." }) {
  return (
    <div className="app-content-loading" role="status" aria-live="polite">
      <Spin size="small" />
      <span>{label}</span>
    </div>
  );
}
